<template>
  <div class="top-wrapper">
    <div class="header-container">
      <div class="header-section">
        <div class="left-section">
          <div class="logo-view">
            <img src="~@/assets/images/logo.png" alt />
          </div>
          <div class="navactivebj">
            <img src="~@/assets/images/navactivebj.png" alt />
          </div>
        </div>
        <div class="right-section">
          <!-- <div class="top-icon-view">
            <span class="el-icon-message-solid"></span>
          </div>-->
          <!-- <div class="top-icon-view">
            <span class="el-icon-s-grid"></span>
          </div>-->
          <el-popover
            placement="bottom"
            width="0"
            trigger="click"
            v-model="visibleSso"
            class="popover-view"
          >
            <div class="infoSso" slot="reference">
              <span class="el-icon-s-grid"></span>
            </div>
            <div class="sys-list">
              <div
                class="itemSys"
                v-for="(item,index) in sysList"
                :key="index"
                @click="linkSso(item)"
                style="cursor: pointer"
              >
                <img class="img-src" :src="item.imgsrc" alt />
                <span>{{item.name}}</span>
              </div>
            </div>
          </el-popover>
          <div class="div-icon">
            <span class="right-icon el-icon-message-solid"></span>
          </div>
          <el-popover placement="bottom" width="0" trigger="click" v-model="popoverSyns">
            <div class="infoEdit" slot="reference">
              <el-avatar size="medium" :src="require('@/assets/images/avatar.png')"></el-avatar>
              <span class="username">{{commonData.USERNAME}}</span>
              <!-- <span class="username">晋之源</span> -->
            </div>
            <div class="menu-list">
              <div class="menu" @click="clickLogout" style="cursor: pointer">退出系统</div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonData from "@/services/model/common-data";
export default {
  data() {
    return {
      commonData: new CommonData(this),
      visibleSso: false,
      popoverSyns: false,
      currentAccountIndex: 0,
      sysList: [
        {
          name: "大数据",
          imgsrc: require("@/assets/images/bigdata.png"),
          ssoUrl: "/bigdata/index.html",
        },
        {
          name: "大数据后台",
          imgsrc: require("@/assets/images/houtai.png"),
          ssoUrl: "/source/main.html",
        },
        {
          name: "精准种植",
          imgsrc: require("@/assets/images/wulianwang.png"),
          ssoUrl: "/cloud/main.html",
        },
        {
          name: "植保防控",
          imgsrc: require("@/assets/images/plantProtectSmall.png"),
          ssoUrl:
            "http://nyzbwlw.com/agro_monitor/loginAuto.jsp?loginName=qwx&loginPass=123456",
        },
        {
          name: "权限管理",
          imgsrc: require("@/assets/images/quanxian.png"),
          ssoUrl: "/febs/index.html",
        },
        {
          name: "溯源管理",
          imgsrc: require("@/assets/images/suyuan.png"),
          ssoUrl: "/source/main.html",
        },

        {
          name: "物联网管理",
          imgsrc: require("@/assets/images/yewu.png"),
          ssoUrl: "/system/index.html",
        },
        {
          name: "ERP系统",
          imgsrc: require("@/assets/images/houtai.png"),
          ssoUrl: "/erp/index.html",
        },
      ],
    };
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    onSelectChange() {},
    clickLogout() {
      localStorage.clear();
      window.location.href = window.backPath;
    },
    linkSso(data) {
      if (data.name != "植保防控") {
        window.location.href = data.ssoUrl;
      } else {
        window.open(data.ssoUrl);
      }
    },
  },
};
</script>
<style lang="scss">
.menu-list {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.top-wrapper {
  .header-container {
    .header-section {
      width: 100%;
      position: fixed;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-section {
        .logo-view {
          height: 100%;
          display: flex;
          align-items: center;
          padding-left: 24px;
        }
        .navactivebj {
          position: absolute;
          width: 179px;
          height: 15px;
          left: 12px;
          bottom: -6px;
        }
      }
      .right-section {
        display: inline-flex;
        align-items: center;
        padding-right: 20px;
        float: right;
        font-size: 14px;
        color: #ffffff;
        position: relative;
        user-select: none;
        .top-icon-view {
          font-size: 20px;
          margin-right: 20px;
          color: #ffffff;
        }
        .infoSso {
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          user-select: none;
          outline: none;
          cursor: pointer;
          font-size: 22px;
          // margin-right: 18px;
        }
        .div-icon {
          .right-icon {
            margin:0 18px;
            font-size: 18px;
          }
        }
        .infoEdit {
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          user-select: none;
          outline: none;
          cursor: pointer;
          .user-avatar {
            width: 40px;
          }
          .username {
            font-size: 14px;
            margin-left: 8px;
            text-align: center;
          }
        }
      }
    }
  }
}
.sys-list {
  width: 150px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .itemSys {
    width: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
    font-size: 12px;
    color: #ffffff;
    .img-src {
      width: 40px;
      height: 40px;
      margin-bottom: 5px;
    }
  }
}
</style>
